import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { useCallback } from 'react';

interface LogActionParams {
  action: string;
  targetType?: string;
  targetId?: string;
  metadata?: Record<string, any>;
}

export const useAuditLog = () => {
  const { user } = useAuth();

  const logAction = useCallback(
    async (params: LogActionParams) => {
      if (!user) return;
      try {
        await supabase.from('audit_logs').insert({
          user_id: user.id,
          action: params.action,
          target_type: params.targetType ?? null,
          target_id: params.targetId ?? null,
          metadata: params.metadata ?? {},
        });
      } catch (e) {
        console.warn('[audit] Failed to log action:', e);
      }
    },
    [user]
  );

  return { logAction };
};
